import axios from 'axios'
import { ref } from 'vue'
import { useCookies } from 'vue3-cookies'
// import Cookies from 'vue3-cookies';

const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})

const { cookies } = useCookies()

export function loadLogin() {
  return 0
}

export async function checkredirectUrl() {
  const redirectUrl = localStorage.getItem('redirectAfterLogin')
  if (redirectUrl) {
    window.location.href = redirectUrl
    localStorage.removeItem('redirectAfterLogin')
  } else {
    window.location.href = '/'
  }
}

// eslint-disable-next-line consistent-return
export async function loginId(userID, userPW, staySigned) {
  const accessToken = ref('')
  const refreshToken = ref('')
  const stayToken = ref('')
  const loginType = 'basic'
  const data = {
    userid: userID.value,
    password: userPW.value,
  }
  try {
    // 세션 : 1시간
    // 액세스 만료시간 : 하루
    // 리프레스 만료시간 : 일주일
    // JWT : 하루
    const loginIDPWRes = await instance.post(
      `/api/v1/member/auth/login/${loginType}`,
      data
    )
    if (staySigned) {
      stayToken.value = cookies.set('stayToken', true, 60 * 60 * 24 * 7)
      accessToken.value = cookies.set(
        'access_token',
        loginIDPWRes.data.content.access_token,
        60 * 60 * 24 * 7
      )
      refreshToken.value = cookies.set(
        'refresh_token',
        loginIDPWRes.data.content.refresh_token,
        60 * 60 * 24 * 7
      )
      checkredirectUrl()
    } else {
      /*
        액세스나 리프레시가 가진 성격으로 운영
        스테이를 사용하여 내가 임의로 7일을 정하는건 X,
        스테이토큰으로 컨트롤하는건 X
        액세스랑 리프레시만으로 
      */
      accessToken.value = cookies.set(
        'access_token',
        loginIDPWRes.data.content.access_token,
        60 * 60 * 3
      )
      refreshToken.value = cookies.set(
        'refresh_token',
        loginIDPWRes.data.content.refresh_token,
        60 * 60 * 3
        // 60 * 60 * 24 * 7
      )
      checkredirectUrl()
    }
  } catch (err) {
    console.log(err.response.data)
    return err.response.data.code
  }
}
export async function loadLoginQr() {
  const qrRes = await instance.get('/api/v1/member/auth/did/qr')
  const detailData = qrRes.data.content

  return detailData
}

export async function sendLoginQr(qrNocne) {
  const loginType = 'did'
  await instance.post(`/api/v1/member/auth/login/${loginType}`, {
    nonce: qrNocne,
  })
}

export async function deleteToken() {
  const getAcc = cookies.get('access_token')
  const headers = { Authorization: getAcc }
  try {
    await instance.post(`/api/v1/member/logout`, null, { headers })
    localStorage.clear()
    cookies.remove('access_token')
    cookies.remove('refresh_token')
    cookies.remove('stayToken')
    window.location.href = '/'
  } catch (err) {
    localStorage.clear()
    cookies.remove('access_token')
    cookies.remove('refresh_token')
    cookies.remove('stayToken')
    window.location.href = '/'
  }
}

const resultUrl = ref('')
const resultSid = ref('')

export async function loadOacxPopup() {
  const oacxRes = await instance.post(`/api/v1/member/auth/oacx/popup`)
  resultUrl.value = oacxRes.data.content.url
  resultSid.value = oacxRes.data.content.sid
  return oacxRes.data
}

export async function loginOacx() {
  const accessToken = ref('')
  const refreshToken = ref('')
  try {
    const loginType = 'oacx'
    const sid = localStorage.getItem('sid')
    // console.log(sid)
    const data = { oacx_sid: sid }
    const headers = { 'Content-Type': 'application/json' }
    // console.log(data)
    const loginOacxRes = await instance.post(
      `/api/v1/member/auth/login/${loginType}`,
      data,
      headers
    )
    // console.log(loginOacxRes)
    if (loginOacxRes.data.code === 'MB20000200') {
      accessToken.value = cookies.set(
        'access_token',
        loginOacxRes.data.content.access_token
      )
      refreshToken.value = cookies.set(
        'refresh_token',
        loginOacxRes.data.content.refresh_token
      )
      localStorage.removeItem('sid')
      localStorage.removeItem('joinType')
      localStorage.removeItem('callbackUrl')
      localStorage.removeItem('baseUrl')
      checkredirectUrl()
    }
    return loginOacxRes.data
  } catch (err) {
    // console.log(err)
    return err.response.data
  }
}
